import '../OverflowTriggerPopover.css';

import { IonIcon, IonItem, IonList, IonPopover } from '@ionic/react';
import { OverflowItem } from '../OverflowTriggerPopover';

interface NestedPopoverItemsProps {
  item: OverflowItem;
  nestedId: string;
  lines: 'none' | 'full';
}

const NestedPopoverItems = ({
  item,
  nestedId,
  lines,
}: NestedPopoverItemsProps) => {
  const children = item.children ?? [];

  return (
    <IonItem
      button={true}
      detail={true}
      disabled={item.disabled}
      id={nestedId}
      key={item.key}
      lines={lines}
    >
      {item.icon && <IonIcon icon={item.icon} slot="start" />}
      {item.label}
      <IonPopover
        trigger={nestedId}
        side="end"
        alignment="start"
        dismissOnSelect={true}
        showBackdrop={false}
      >
        {/* Plain scrollable div, not IonContent: IonContent inside IonPopover
            ignores mouse-wheel scrolling on desktop. */}
        <div className="overflow-popover-content">
          <IonList>
            {children.map((child, childIndex) => (
              <IonItem
                button={true}
                onClick={child.onClick}
                disabled={child.disabled}
                key={child.key}
                lines={childIndex === children.length - 1 ? 'none' : 'full'}
              >
                {child.icon && <IonIcon icon={child.icon} slot="start" />}
                {child.label}
              </IonItem>
            ))}
          </IonList>
        </div>
      </IonPopover>
    </IonItem>
  );
};

export default NestedPopoverItems;
